import './../css/app.css';

import Alpine from 'alpinejs';
import { initAnimations } from './animations';
import { initHeader } from './header';
import { initHero } from './blocks/hero';
import { initPresentazione } from './blocks/presentazione';
import { initIntroTesto } from './blocks/intro-testo';
import { initIntroAnimata } from './blocks/intro-animata';
import { initStatistiche } from './blocks/statistiche';
import { initServizi } from './blocks/servizi';
import { initPillar } from './blocks/pillar';
import { initCamere } from './blocks/camere';
import { initDintorni } from './blocks/dintorni';
import { initDintorniEsperienze } from './blocks/dintorni-esperienze';
import { initMarquee } from './blocks/marquee';
import { initGalleriaGriglia } from './blocks/galleria-griglia';
import { initOfferteGriglia } from './blocks/offerte-griglia';
import { initSingleOfferta } from './blocks/single-offerta';
import { initParallaxImg } from './blocks/parallax-img';
import { initCarousels } from './carousel';
import { initLightbox } from './lightbox';
import { initTracking } from './tracking';

// Store globale della stagione: header e blocchi (es. hero) vi reagiscono insieme.
Alpine.store( 'season', {
	current: 'winter', // 'winter' | 'summer'
	set( s ) {
		this.current = s;
	},
} );

window.Alpine = Alpine;

// Stagione iniziale decisa lato PHP (data-season sul body).
const initial = document.body?.dataset?.season;
if ( initial ) {
	Alpine.store( 'season' ).current = initial;
}

Alpine.start();

// Riflette la stagione corrente su body[data-season]: il crossfade delle immagini
// hero è gestito via CSS (vale anche nell'anteprima editor, dove il body non ha l'attributo).
Alpine.effect( () => {
	document.body.dataset.season = Alpine.store( 'season' ).current;
} );

// Nell'editor a blocchi non avviare le animazioni GSAP (nasconderebbero i contenuti).
const isEditor = document.body.classList.contains( 'block-editor-iframe__body' )
	|| document.documentElement.classList.contains( 'wp-toolbar' )
	|| window.location.href.indexOf( 'wp-admin' ) !== -1;

const start = () => {
	if ( isEditor ) {
		return;
	}
	// Tracking CTA → dataLayer: prima di tutto, non dipende da GSAP né da GTM.
	initTracking();
	initAnimations();
	initHeader();
	initHero();
	initPresentazione();
	initIntroTesto();
	initIntroAnimata();
	initStatistiche();
	initServizi();
	initPillar();
	initCamere();
	initDintorni();
	initDintorniEsperienze();
	initMarquee();
	initGalleriaGriglia();
	initOfferteGriglia();
	initSingleOfferta();
	// Parallasse condivisa delle foto full-bleed (chiusura + dove-siamo).
	initParallaxImg( '[data-tm-chiusura], [data-tm-dove-siamo]' );
	initCarousels();
	initLightbox();
};

if ( document.readyState !== 'loading' ) {
	start();
} else {
	document.addEventListener( 'DOMContentLoaded', start );
}
